import styled from 'styled-components';

export const TipoLabel = styled.span``;
